import { Controller } from "@hotwired/stimulus"

// Makes a table row navigable like a link. Skips navigation when the click
// lands on an interactive descendant (link, button, input) so nested controls
// keep their own behaviour.
export default class extends Controller<HTMLElement> {
  static values = { url: String }

  declare urlValue: string

  go(event: MouseEvent): void {
    const target = event.target as HTMLElement | null
    if (target?.closest("a, button, input, select, textarea, label, dialog")) return
    window.location.assign(this.urlValue)
  }
}
